import { render } from "./TrainingShow.vue?vue&type=template&id=e4ca4060&scoped=true"
import script from "./TrainingShow.vue?vue&type=script&lang=js"
export * from "./TrainingShow.vue?vue&type=script&lang=js"

import "./TrainingShow.vue?vue&type=style&index=0&id=e4ca4060&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ca4060"]])

export default __exports__